webpackJsonp([19],{

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(212);
//导入依赖



//引入组件模板(定义路由组件)
//列表页路由
// const Index = () => import ('@/components/index');
// const Knowledge = () => import ('@/components/content/knowledge/list');
// import NotFoundComponent from '@/components/common/notFoundComponent';
// import Search from '@/components/search';
// import Activity from '@/components/content/activity/list';
// import Industry from '@/components/content/industry/list';
// import Knowledge from '@/components/content/knowledge/list';
// import RecruitInner from '@/components/content/recruit/inner/list';
// import RecruitOuter from '@/components/content/recruit/outer/list';

// 详情页路由
// import actDetail from '@/components/content/activity/detail';
// import innerDetail from '@/components/content/recruit/inner/detail';
// import outerDetail from '@/components/content/recruit/outer/detail';
// import knowDetail from '@/components/content/knowledge/detail';
// import indusDetail from '@/components/content/industry/detail';

//将路由引入vue中
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

//创建router实例，配置路由(运用路由懒加载模式)
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [
  /**404页面**/
  {
    path: '*',
    name: 'Error',
    redirect: '/error/404'
  }, {
    path: '/error/404',
    name: 'Error',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(222)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  /**已下架、已删除**/
  {
    path: '/empty',
    name: 'Empty',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(221)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  /**默认路由**/
  {
    path: '/',
    redirect: '/recruit/inner/list'
  },
  /**首页**/
  {
    path: '/index',
    name: 'Index',
    // component: Index,
    component: function component(resolve) {
      return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(233)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '面包求职－做个学院，一起烘焙面包。精选干货，内部推荐，行业招聘，行业动态，面包新闻。'
    }
  },
  /**搜索页面**/
  {
    path: '/search',
    name: 'Search',
    // component: Search,
    component: function component(resolve) {
      return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(234)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '面包求职－做个学院，一起烘焙面包。精选干货，内部推荐，行业招聘，行业动态，面包新闻。'
    }
  },
  /**干货页面**/
  {
    path: '/knowledge/list',
    name: 'Knowledge',
    // component: Knowledge,
    component: function component(resolve) {
      return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(228)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '精选干货，深度剖析全行业现状'
    }
  }, {
    path: '/knowledge/detail/:id',
    name: 'KnowledgeDetail',
    // component: knowDetail
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(227)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  /**活动页面**/
  {
    path: '/activity/list',
    name: 'Activity',
    // component: Activity,
    component: function component(resolve) {
      return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(224)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '必听讲座，超大礼包，求职路上轻松开挂'
    }
  }, {
    path: '/activity/detail/:id',
    name: 'ActivityDetail',
    // component: actDetail
    component: function component(resolve) {
      return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(223)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  /**内推页面**/
  {
    path: '/recruit/inner/list',
    name: 'RecruitInner',
    // component: RecruitInner,
    component: function component(resolve) {
      return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(230)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '海量内推，助力你的名企Offer梦'
    }
  }, {
    path: '/recruit/inner/detail/:id',
    name: 'RecruitInnerDetail',
    // component: innerDetail
    component: function component(resolve) {
      return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(229)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  /**招聘页面**/
  {
    path: '/recruit/outer/list',
    name: 'RecruitOuter',
    // component: RecruitOuter,
    component: function component(resolve) {
      return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(232)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '包罗万象，无限拓宽你的求职道路'
    }
  }, {
    path: '/recruit/outer/detail/:id',
    name: 'RecruitOuterDetail',
    // component: outerDetail
    component: function component(resolve) {
      return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(231)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  /**新闻页面**/
  {
    path: '/industry/list',
    name: 'Industry',
    // component: Industry,
    component: function component(resolve) {
      return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(226)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '面包资讯，新鲜出炉的行业深度报道'
    }
  }, {
    path: '/industry/detail/:id',
    name: 'IndustryDetail',
    // component: indusDetail
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(225)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
});
/* harmony default export */ __webpack_exports__["a"] = (router);

router.beforeEach(function (to, from, next) {
  next();
});

/***/ }),

/***/ 153:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 154:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 155:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 156:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(190)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(209),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function (){
    'use strict';
    var Util = Util || {};
    Util.Domain = Util.Domain || {
        _urlEnd: '.oss-cn-beijing.aliyuncs.com/',
        _protocolStr: 'http://',
        _imgPre: 'img-bo',
        _docPre: 'doc-bo',
        _videoPre: 'video-bo',
        _env: 'env',
        getImg: function (){
            return this._getValueByType(this._imgPre);
        },
        getDoc: function (){
            return this._getValueByType(this._docPre);
        },
        getVideo: function (){
            return this._getValueByType(this._videoPre);
        },
        _getValueByType: function(type) {
            return this._protocolStr.concat(type).concat(this._getEnv()).concat(this._urlEnd);
        },
        _getEnv: function() {
            var arr,reg=new RegExp("(^| )" + this._env + "=([^;]*)(;|$)");
            if(arr=document.cookie.match(reg))
                return '-'.concat(decodeURIComponent(arr[2]));
            else
                return '';
        }
    };
    return Util;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(150);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_header__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_content_content__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_content_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_content_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer_footer__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_footer_footer__);
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'v-header': __WEBPACK_IMPORTED_MODULE_0__components_header_header___default.a,
    'v-content': __WEBPACK_IMPORTED_MODULE_1__components_content_content___default.a,
    'v-footer': __WEBPACK_IMPORTED_MODULE_2__components_footer_footer___default.a
  }
});

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['loginCssStatus'], // 绑定在搜索页的样式
	data: function data() {
		return {
			baceUrl: 'http://member.breadoffer.com/', // 登录、注册基本路径
			loginArr: [//已登录状态下拉数据渲染
			{ icon: '&#xe64e;', class: 'gerenxinxi', url: 'index.html', name: '会员中心' }, { icon: '&#xe64d;', class: 'shujiaxuanzhong', url: 'coursepool/course.html#sl_1', name: '我的课程' }, { icon: '&#xe6a7;', class: 'dingdan', url: 'coursepool/course.html#sl_2', name: '我的订单' }, { icon: '&#xe63f;', class: 'youhuima', url: 'value/coupon.html', name: '我的优惠' }, { icon: '&#xe647;', class: 'shezhi', url: 'user/info.html', name: '账户设置' }]
		};
	},

	methods: {
		// 鼠标移入移出效果
		loginFn: function loginFn() {
			$(".logined .logined-show").hover(function () {
				$(this).addClass('active-hover');
				$(this).find('ul').show();
			}, function () {
				$(this).removeClass('active-hover');
				$(this).find("ul").hide();
			});
		}
	},
	mounted: function mounted() {
		this.loginFn();
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return { status: false };
  },

  methods: {
    //在详情页中,背景色改变
    changeColor: function changeColor() {
      this.status = this.$route.name.indexOf('Detail') !== -1;
    }
  },
  // 监听路由变化
  watch: {
    "$route": "changeColor" //路由变化时，改变背景色
  }
});

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_iview__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_iview__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // 引入气泡提示组件

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      status: true, // 用来控制更多右侧展开、收起样式
      baceUrl: 'http://breadoffer.com/', // 更多bace链接
      tipsArr: [//渲染更多弹出框数据
      { icon: '&#xe653;', url: '', name: '返回面包首页' }, { icon: '&#xe64d;', url: 'course/list.html', name: '课程频道' }, { icon: '&#xe6df;', url: 'teacher/list.html', name: '导师频道' }, { icon: '&#xe6db;', url: 'gain.html', name: '学员成果' }, { icon: '&#xe6de;', url: 'job/recruit.html', name: '导师招募' }, { icon: '&#xe6dd;', url: 'aboutus/join.html', name: '加入我们' }, { icon: '&#xe6da;', url: 'aboutus/index.html', name: '关于我们' }, { icon: '&#xe6dc;', url: 'aboutus/qa.html', name: '常见问题' }]
    };
  },

  components: {
    'Tooltip': __WEBPACK_IMPORTED_MODULE_0_iview__["Tooltip"]
  },
  methods: {
    enter: function enter() {
      this.status = false;
    },
    leave: function leave() {
      this.status = true;
    }
  }
});

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_login__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // 引入已登录样式组件


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'v-login': __WEBPACK_IMPORTED_MODULE_0__common_login___default.a
  },
  data: function data() {
    return {
      baceUrl: 'http://member.breadoffer.com/', // 登录、注册基本路径
      pathName: '', // 路由名
      formName: '', // url中form参数
      width: 75, // 默认头部导航宽度
      decorateLeft: 75, // 头部跟随导航条左偏移量
      index: '', // 头部导航下标
      inputWidth: '', // 搜索框宽度(用于动画效果)
      holder: '搜索', // 搜索框默认placeholder
      keywords: '', // 搜索框关键词
      loginCssStatus: false, // 控制搜索页的登录/注册样式
      // 路由切换、logo右侧标签内容
      routeArr: [{ name: '首页', url: 'http://breadoffer.com', listPath: 'Index', detailPath: '', simpleName: '首页' }, { name: '内推', url: 'http://college.breadoffer.com/recruit/inner/list', listPath: 'RecruitInner', detailPath: 'RecruitInnerDetail', simpleName: '内推' }, { name: '课程', url: 'http://breadoffer.com/course/list.html', listPath: 'Course', detailPath: 'KnowledgeDetail', simpleName: '干货' }, { name: '导师', url: 'http://breadoffer.com/teacher/list.html', listPath: 'Teacher', detailPath: 'KnowledgeDetail', simpleName: '干货' }, { name: '成果', url: 'http://breadoffer.com/gain.html', listPath: 'Knowledge', detailPath: 'KnowledgeDetail', simpleName: '干货' }, { name: '关于', url: 'http://breadoffer.com/aboutus/index.html', listPath: 'Knowledge', detailPath: 'KnowledgeDetail', simpleName: '干货'
        // {name:'活动',url:'/activity/list',listPath:'Activity',detailPath:'ActivityDetail', simpleName:'活动'},

        // {name:'招聘',url:'/recruit/outer/list',listPath:'RecruitOuter',detailPath:'RecruitOuterDetail', simpleName:'招聘'},
        // {name:'新闻',url:'/industry/list',listPath:'Industry',detailPath:'IndustryDetail', simpleName:'新闻'},
      }]
    };
  },

  methods: {
    //鼠标移入时导航条跟随效果
    changeLeft: function changeLeft(index) {
      this.decorateLeft = this.width * index;
    },

    //鼠标移出时导航条恢复默认位置
    backLeft: function backLeft() {
      var currentPath = this.$route.query.form || this.pathName;
      //index的值：搜索页根据路径中的form参数，其他页根据路由的pathName值
      //findIndex：返回满足条件的元素的索引值
      if (currentPath !== 'Error') {
        // 从404/下架页面跳转到搜索页导航条默认left为0
        var index = this.routeArr.findIndex(function (element, index, array) {
          return currentPath == element.listPath || currentPath == element.detailPath;
        });
        // console.warn('decorateLeft', this.decorateLeft)
        this.decorateLeft = this.width * index; // 跟随条左偏移量的值
      } else {
        this.decorateLeft = this.width * 0; // 404页面默认left为0
      }
      this.decorateLeft = 75;
    },

    //获取当前页面路径，改变标签文字
    pathFn: function pathFn() {
      this.pathName = this.$route.name;
      this.formName = this.GetQueryString("form");
      //搜索页头部无搜索框,登陆/注册按钮靠右侧的样式
      this.loginCssStatus = this.pathName === 'Search';
      //切换路由时，需要初始化的函数
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()("input[type='text']").val(''); // 搜索框恢复默认
      this.initTop(); // 初始化滚动条
      this.backLeft(); // 导航跟随条恢复默认位置
      this.leave(); // 搜索框鼠标移出
      this.fixedNav(); // 监听滚动条，改变样式
    },

    //切换路由，初始化滚动条高度
    initTop: function initTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },

    //监听滚动条，改变导航样式
    fixedNav: function fixedNav() {
      var _this = this;

      this.$nextTick(function () {
        var tops = document.body.scrollTop || document.documentElement.scrollTop; //同时兼容谷歌与火狐
        if (tops >= _this.top) {
          _this.nav.className = 'header';
        }
        //如果是内推和招聘页，头部导航改为透明背景的样式,其他页为白色背景
        if (tops == 0 && (_this.pathName == 'RecruitInner' || _this.pathName == 'RecruitOuter')) {
          _this.nav.className = 'active';
        } else {
          _this.nav.className = 'header';
        }
      });
    },

    // 搜索框移入移出事件
    handleFocus: function handleFocus() {
      this.holder = '';
    },
    handleBlur: function handleBlur() {
      this.holder = '搜索';
    },
    enter: function enter() {
      this.inputWidth = 250; // 鼠标移入，输入框长度变为250px;
    },
    leave: function leave() {
      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()("input").is(":focus")) {
        this.inputWidth = 250; // 当鼠标移出,并且此时input已获取焦点，长度变为250px;
      } else {
        this.inputWidth = 150; // 当鼠标移出,但此时input未获取焦点，长度仍为150px;
      }
    },

    //点击搜索函数
    search: function search() {
      this.keywords = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.trim(this.$refs.myInput.value);
      if (this.keywords) {
        this.$router.push({ path: '/search', query: { keywords: this.keywords, form: this.$route.name } }); // 切换搜索路由，用query传递参数
      } else {
        this.$router.push({ path: '/search', query: { keywords: '', form: this.$route.name } });
      }
    },
    GetQueryString: function GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);return null;
    }
  },
  //在计算属性中获取导航距离顶端的高度
  computed: {
    top: function top() {
      return this.nav.offsetTop;
    }
  },
  mounted: function mounted() {
    this.nav = this.$refs.myNav; // 获取头部导航元素
    this.pathFn();
    this.fixedNav();
    window.addEventListener('scroll', this.fixedNav);
  },

  //监听路由变化
  watch: {
    "$route": "pathFn" //路由变化时，改变标签内容
    // "pathName":"fixedNav" // 标签内容改变时，改变导航样式
  }
});

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery_mousewheel__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery_mousewheel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery_mousewheel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_js_util__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_js_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_js_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_css_reset_css__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__static_css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_css_plugin_common_css__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_css_plugin_common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__static_css_plugin_common_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_css_reply_css__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_css_reply_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__static_css_reply_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_css_animate_css__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_css_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__static_css_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_iview_dist_styles_iview_css__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_iview_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_iview_dist_styles_iview_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

 // 页面主入口
 // 路由
 // 数据请求
 // 轮播图

 // 时间插件



// axios.defaults.withCredentials=true;
// 设置为 false 以阻止 vue 在启动时生成生产提示;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

//切换路由时改变列表页title
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__(159));

// Vue.prototype.HOST = '/member/api';
// 创建基本的axios配置
// var $http = axios.create({
//   baseURL:'http://college.breadoffer.com'
// })
// Vue.prototype.$http =  $http;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;
// 设置全局图片基本url
// Vue.prototype.resourceUrl = 'http://resource.breadoffer.com';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.resourceUrl = __WEBPACK_IMPORTED_MODULE_8__static_js_util___default.a.Domain.getImg();
// Vue.prototype.resourceUrl =  window.resourceUrl;

// 通过url获取参数的函数
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.GetQueryString = function (name) {
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
		var r = window.location.search.substr(1).match(reg);
		if (r != null) return unescape(r[2]);return null;
};

//将空格转为换行的函数
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.formatSolution = function (text) {
		if (text) {
				return text.replace(/\n/g, '<br/>');
		} else return '';
};
// 关于时间的过滤器
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('moment', function (date) {
		__WEBPACK_IMPORTED_MODULE_6_moment___default.a.locale('zh-cn'); //设置为中文(列表页)
		return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).fromNow();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('Moment', function (date) {
		__WEBPACK_IMPORTED_MODULE_6_moment___default.a.locale('en'); //设置为英文(banner部分)
		return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date, 'YYYYMMDD').format('MMMM Do, YYYY');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('Month', function (date) {
		__WEBPACK_IMPORTED_MODULE_6_moment___default.a.locale('en'); //设置为英文
		return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format('MMM'); //右侧活动转化为月份
});

// 导入公共部分
 // 重置样式
 // 修改插件样式的css
 // 评论回复样式
 // 动画css
 // iview组件css
__webpack_require__.e/* require */(16).then(function() {[__webpack_require__(218)];}).catch(__webpack_require__.oe);
__webpack_require__.e/* require */(14).then(function() {[__webpack_require__(217)];}).catch(__webpack_require__.oe);
__webpack_require__.e/* require */(15).then(function() {[__webpack_require__(216)];}).catch(__webpack_require__.oe);
__webpack_require__.e/* require */(17).then(function() {[__webpack_require__(215)];}).catch(__webpack_require__.oe);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_jquery_mousewheel___default.a);

/* eslint-disable no-new */
var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
		el: '#app',
		router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
		template: '<App/>',
		components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
		updated: function updated() {
				if (window.location.href.indexOf('404' || 'empty') == -1) {
						__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.content').mCustomScrollbar("destroy"); // 在页面刷新前将滚动条样式清除，恢复到默认样式
				}
		}
});

// 切换路由时需执行的操作
vm.$watch('$route', function () {
		// 调用滚动动条函数
		if (window.location.href.indexOf('404' || 'empty') == -1) {
				__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.content').mCustomScrollbar();
		}

		//首页轮播图函数
		var btn = __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#shouye-btn1,#shouye-btn2');
		btn.on('click', function () {
				getbanner('.swiper-slide-active');
		});
		// 将轮播图放入左侧div中
		function getbanner(className) {
				var item = __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.img-wrap').find(className).prev();
				var src = item.find('img').attr('src');
				var href = item.find('a').attr('href');
				var label = item.find('a').find('.ban-text').find('h4').text();
				var title = item.find('a').find('.title').text();
				var desc = item.find('a').find('.desc').text();
				__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.banner-left').addClass('fadeIn');
				setTimeout(function () {
						__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.banner-left').removeClass('fadeIn');
				}, 1000);
				__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.banner-left').find('img').attr('src', src);
				__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.banner-left').find('a').attr('href', href);
				__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.banner-left').find('a').find('.ban-text').find('h3').text(label);
				__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.banner-left').find('a').find('.ban-text').find('.title').text(title);
				__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.banner-left').find('a').find('.ban-text').find('.desc').text(desc);
		}

		// 列表页下拉菜单悬停效果
		__WEBPACK_IMPORTED_MODULE_5_jquery___default()(".industry-select,.city-select,.type-select").on("mouseover", ".wanna-hover", function () {
				__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).find('.hover-span').stop(true, true).animate({ width: '20px', marginRight: '6px' }, 'normal');
		});
		__WEBPACK_IMPORTED_MODULE_5_jquery___default()(".industry-select,.city-select,.type-select").on("mouseout", ".wanna-hover", function () {
				__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).find('.hover-span').stop(true, true).animate({ width: '0', marginRight: '0' }, 'normal');
		});
});

/***/ }),

/***/ 187:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 189:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 190:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 191:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 14,
	"./af.js": 14,
	"./ar": 21,
	"./ar-dz": 15,
	"./ar-dz.js": 15,
	"./ar-kw": 16,
	"./ar-kw.js": 16,
	"./ar-ly": 17,
	"./ar-ly.js": 17,
	"./ar-ma": 18,
	"./ar-ma.js": 18,
	"./ar-sa": 19,
	"./ar-sa.js": 19,
	"./ar-tn": 20,
	"./ar-tn.js": 20,
	"./ar.js": 21,
	"./az": 22,
	"./az.js": 22,
	"./be": 23,
	"./be.js": 23,
	"./bg": 24,
	"./bg.js": 24,
	"./bm": 25,
	"./bm.js": 25,
	"./bn": 27,
	"./bn-bd": 26,
	"./bn-bd.js": 26,
	"./bn.js": 27,
	"./bo": 28,
	"./bo.js": 28,
	"./br": 29,
	"./br.js": 29,
	"./bs": 30,
	"./bs.js": 30,
	"./ca": 31,
	"./ca.js": 31,
	"./cs": 32,
	"./cs.js": 32,
	"./cv": 33,
	"./cv.js": 33,
	"./cy": 34,
	"./cy.js": 34,
	"./da": 35,
	"./da.js": 35,
	"./de": 38,
	"./de-at": 36,
	"./de-at.js": 36,
	"./de-ch": 37,
	"./de-ch.js": 37,
	"./de.js": 38,
	"./dv": 39,
	"./dv.js": 39,
	"./el": 40,
	"./el.js": 40,
	"./en-au": 41,
	"./en-au.js": 41,
	"./en-ca": 42,
	"./en-ca.js": 42,
	"./en-gb": 43,
	"./en-gb.js": 43,
	"./en-ie": 44,
	"./en-ie.js": 44,
	"./en-il": 45,
	"./en-il.js": 45,
	"./en-in": 46,
	"./en-in.js": 46,
	"./en-nz": 47,
	"./en-nz.js": 47,
	"./en-sg": 48,
	"./en-sg.js": 48,
	"./eo": 49,
	"./eo.js": 49,
	"./es": 53,
	"./es-do": 50,
	"./es-do.js": 50,
	"./es-mx": 51,
	"./es-mx.js": 51,
	"./es-us": 52,
	"./es-us.js": 52,
	"./es.js": 53,
	"./et": 54,
	"./et.js": 54,
	"./eu": 55,
	"./eu.js": 55,
	"./fa": 56,
	"./fa.js": 56,
	"./fi": 57,
	"./fi.js": 57,
	"./fil": 58,
	"./fil.js": 58,
	"./fo": 59,
	"./fo.js": 59,
	"./fr": 62,
	"./fr-ca": 60,
	"./fr-ca.js": 60,
	"./fr-ch": 61,
	"./fr-ch.js": 61,
	"./fr.js": 62,
	"./fy": 63,
	"./fy.js": 63,
	"./ga": 64,
	"./ga.js": 64,
	"./gd": 65,
	"./gd.js": 65,
	"./gl": 66,
	"./gl.js": 66,
	"./gom-deva": 67,
	"./gom-deva.js": 67,
	"./gom-latn": 68,
	"./gom-latn.js": 68,
	"./gu": 69,
	"./gu.js": 69,
	"./he": 70,
	"./he.js": 70,
	"./hi": 71,
	"./hi.js": 71,
	"./hr": 72,
	"./hr.js": 72,
	"./hu": 73,
	"./hu.js": 73,
	"./hy-am": 74,
	"./hy-am.js": 74,
	"./id": 75,
	"./id.js": 75,
	"./is": 76,
	"./is.js": 76,
	"./it": 78,
	"./it-ch": 77,
	"./it-ch.js": 77,
	"./it.js": 78,
	"./ja": 79,
	"./ja.js": 79,
	"./jv": 80,
	"./jv.js": 80,
	"./ka": 81,
	"./ka.js": 81,
	"./kk": 82,
	"./kk.js": 82,
	"./km": 83,
	"./km.js": 83,
	"./kn": 84,
	"./kn.js": 84,
	"./ko": 85,
	"./ko.js": 85,
	"./ku": 86,
	"./ku.js": 86,
	"./ky": 87,
	"./ky.js": 87,
	"./lb": 88,
	"./lb.js": 88,
	"./lo": 89,
	"./lo.js": 89,
	"./lt": 90,
	"./lt.js": 90,
	"./lv": 91,
	"./lv.js": 91,
	"./me": 92,
	"./me.js": 92,
	"./mi": 93,
	"./mi.js": 93,
	"./mk": 94,
	"./mk.js": 94,
	"./ml": 95,
	"./ml.js": 95,
	"./mn": 96,
	"./mn.js": 96,
	"./mr": 97,
	"./mr.js": 97,
	"./ms": 99,
	"./ms-my": 98,
	"./ms-my.js": 98,
	"./ms.js": 99,
	"./mt": 100,
	"./mt.js": 100,
	"./my": 101,
	"./my.js": 101,
	"./nb": 102,
	"./nb.js": 102,
	"./ne": 103,
	"./ne.js": 103,
	"./nl": 105,
	"./nl-be": 104,
	"./nl-be.js": 104,
	"./nl.js": 105,
	"./nn": 106,
	"./nn.js": 106,
	"./oc-lnc": 107,
	"./oc-lnc.js": 107,
	"./pa-in": 108,
	"./pa-in.js": 108,
	"./pl": 109,
	"./pl.js": 109,
	"./pt": 111,
	"./pt-br": 110,
	"./pt-br.js": 110,
	"./pt.js": 111,
	"./ro": 112,
	"./ro.js": 112,
	"./ru": 113,
	"./ru.js": 113,
	"./sd": 114,
	"./sd.js": 114,
	"./se": 115,
	"./se.js": 115,
	"./si": 116,
	"./si.js": 116,
	"./sk": 117,
	"./sk.js": 117,
	"./sl": 118,
	"./sl.js": 118,
	"./sq": 119,
	"./sq.js": 119,
	"./sr": 121,
	"./sr-cyrl": 120,
	"./sr-cyrl.js": 120,
	"./sr.js": 121,
	"./ss": 122,
	"./ss.js": 122,
	"./sv": 123,
	"./sv.js": 123,
	"./sw": 124,
	"./sw.js": 124,
	"./ta": 125,
	"./ta.js": 125,
	"./te": 126,
	"./te.js": 126,
	"./tet": 127,
	"./tet.js": 127,
	"./tg": 128,
	"./tg.js": 128,
	"./th": 129,
	"./th.js": 129,
	"./tk": 130,
	"./tk.js": 130,
	"./tl-ph": 131,
	"./tl-ph.js": 131,
	"./tlh": 132,
	"./tlh.js": 132,
	"./tr": 133,
	"./tr.js": 133,
	"./tzl": 134,
	"./tzl.js": 134,
	"./tzm": 136,
	"./tzm-latn": 135,
	"./tzm-latn.js": 135,
	"./tzm.js": 136,
	"./ug-cn": 137,
	"./ug-cn.js": 137,
	"./uk": 138,
	"./uk.js": 138,
	"./ur": 139,
	"./ur.js": 139,
	"./uz": 141,
	"./uz-latn": 140,
	"./uz-latn.js": 140,
	"./uz.js": 141,
	"./vi": 142,
	"./vi.js": 142,
	"./x-pseudo": 143,
	"./x-pseudo.js": 143,
	"./yo": 144,
	"./yo.js": 144,
	"./zh-cn": 145,
	"./zh-cn.js": 145,
	"./zh-hk": 146,
	"./zh-hk.js": 146,
	"./zh-mo": 147,
	"./zh-mo.js": 147,
	"./zh-tw": 148,
	"./zh-tw.js": 148
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 193;

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/erweima.395e9e9.png";

/***/ }),

/***/ 197:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALUAAACACAYAAABN5Ci3AAAKB0lEQVR4Xu2dUXIcNRCGpX3igSoy2hfeSIoDkJwA5wQkJyA5AeEEJCcgOQHOCeAGxCfAPgCFc4Cdcap4tqimtM5I0xr1zEqyV/5dlQdqtC3p72+kVksatMIfFGhMAd1Yf9AdKKAANSBoTgFA3ZxL0SFADQaaUwBQN+dSdAhQg4HmFADUzbkUHQLUYKA5BQB1cy5FhwA1GGhOAUDdnEvRIUANBppTAFA351J0CFCDgeYUANTNuRQdAtRgoDkFAHVzLkWHADUYaE4BQN2cS9EhQA0GmlMAUDfnUnQIUIOB5hQA1M25FB0C1GCgOQUAdXMuRYcANRhoTgFA3ZxL0SFADQaaUwBQN+dSdAhQg4HmFADUzbkUHQLUYKA5BQB1cy5FhwA1GGhOAUDdnEvRIUANBppTAFA351J0CFCDgeYUANTNuRQdAtRgoDkFAHVzLkWHADUYaE4BQN2cS9EhQA0GmlMAUDfnUnQIUIOB5hQA1M25FB0C1GCgOQUAdXMuRYeOGuphGB5ba38du1Fr/XPXdeetuXYYhhfW2h/H/TLGPF3Sz77v/7wPWh071CfW2tBRT7uu+7DE2cdQdrfbvdZa/xJAvch/fd/bAOomtfJE4UaDu+TwcBQehmEC9S2291xr/abruj/CNmTS9aFSiv6N/5a+vCdzUO92u7da6++Yeq6UUvTP+7PWfqG1/jp40R6N/9u9jN9n9suV1vpdbPDyoOZGg8yNOcic1tobWe4Y1NS3K2NMF3byruoa6tn3Pb0kBwFojLlhqnC/CewnXdddhnofO9QPrLXDQW9K5h+HoJD5ws5d3YPSUOd4SeY6x2lN5Y8aagcMTZk/rfZs5h8eEdSftNaPxyNdDgjHI3UOewdD7WK/F5n9nM2c1voVl9mgLIhS6kG2iuSGuOzLZPGVQ1dr7UOt9TdB087kTf1c0lp7vtlsTkMtXUxNWnohiLX2o9Z6Ms07zSkGv/lLQP1RKcXZkXSD/OvVJRqpJZZR5rMCXEwfE/pQ3XJkP6RtCLMk1to32+32dfh7rv9zUMfsSNq1ROtFKSFJ5fepzBKhD9UFUE8zXRipD6WK+T2gnoJ2J0dq5yhaeN1GjMqiZ6293Gw2lJf0dgq5HcXc7MbqpnqkUA/DQPnlMB5mm9p1HRsnLxmpqV1KKW+jJaYLVx8TfpxSDD6ycdF13dVRhB8kvrX2n9xgZLJHeclHJObeXsU89aTuJVAvTOlRXS/DTRwJ1M5/tMMabtJEXTAeWfeFQqjDH++n/aOAeqH4mViVm7nNzRcufpOO1Ct0vTTGcDtzs9vkLnuxKL0JqOX8FSl5j6BWIWySkXpNXvi+Qu3FeJnypZRvHMfsFFJcBG9CMi/pYuq3Rd6gIFdbeaQG1IFTpbMi/Sy5o7hmxEhBxowoZ8YY77DNkk6k6lvzXHKiTdpGt1Cci3MnmzhrdGd0vaANq7n+c4eCmIXi+2CheL5yoRguOJe4hjTyBjBRSk8yxUnKpFp636BO6ZFacNHvJbpLdE21hZ6X2nyR1L2kTFGolVKiI5D7o6MS8aWj4BIRlpTNOVKn6gXUKYX456WhFrVq3whA7cvVKtS73e5Ua+3d1hGBIizkjp5ObjlliamFbVCAmlfqrkNNM7HWejwbn1Esnmq3y5vTpQnvIJKUl7lyc+dIjh7q0a6it9DMIdzYxiHZj1RbUnDcdkwdtn8PlKTdqb6XeJ4LatERyP3R0ZzhR9/3dEmg+JY+oP6M372Amkvgz72BuaB2o/RfJd720CagPgxqF4r8NtbVWnvGHWl1GRgKW74alaercs8lvs4yUt8i1LUu3tIhebol4l0+zZWhkaTrJGWYweLSLaYml2YTg453GCq8JKC1pgsGp0vCD679Wuvn3EXlWLjlzsSMD1ax3cgCtdZ6coA8Itp7uj6UcaSeQG2tfX/A7Qq22ZvN5m0INBWk0ef6+tq7KeRulIhvd7hbMd4IppT6ZIzxQioJ1JFsw4cV3wcJoV51SWAsZt/3pMn4pOJHY0x0QypyuG5yJoZzWBaoJVMClcmd/cg1Ukrbn7ucC5/oVJ0HMDciSaB2IFCKazxtK2vt6Xa7fSltf67Nl319nJ+ste+22+3sbif3kkpuFgFqqaczlxuGgW7C03rAG61izpZA7WYP2k6m9JsHtnTqdvFs1pE6AicdI56d0SKjdXLmAdSZYZWa6/ueRlQvf0uh03a7ZS8+S6F2YD+z1v4uWexy7c05UruXl87oj2ejyVmfmG5939OC8Yfx89RoDailFGYsF4l9L4wxdJOb/VsCtQObvr0Xxup0AYFuu89+a5C5JEAjauw2udfmMGnArRmWzBqR0CX68v8f5o4VlAgnKZPyf8mFYuotTrVtyfM1MX1kYUin6U64xei+PWt0j1waoM+jEdjRjEjq5sucRiHUzIw0WQSnNOfOibtbUGz40iLUtPio9dVT8XHIUbwb5tUnH5XhnLwGarITmRXOjTFPZqZ8At6LyVPg7Z+PoeZi4rkQK1bHMAyTcGrOThJq5gRejg8Vhh+fIRFDECkG86a227z5InVqbKZwDiagx7ElAU0jdPQlnLuHKd0fiMTv0YzImmthHNScndghpJS+TEqQsmkdN+NIoE7VV+35sULtFkuUugtf0ujmw17UHFC7+ikjEn7hiL7lzd4cGobh1fX1der4AX01Kvxm9g1TDIiz64Y5kLiwLXaoKfyU76vwI+bViBVUxI2Cfd+vnioFVS4uwo2ekZQW3RhP7o7NQD27eRE2PJbDntvVS3V+bkeRCxmWLBC5uhlfs7f8Q6jv8icSYlvVtMqn0WZVDJhy3JLn0k0TycZDaqReA4jb7Alz2KKMCKcDd0d0fy2PRnpr7bPx77TWz+YWqCmtIzZfh1fSJp8do4bS1i+ddUhVcsDzb5VSX45+/69S6u+YPdpMWLr9fEDbsv7UfVjGs7nk/3RAoUMYttD6Yy0ckfuSV6k0X1ZRChvDt/QKCwzz9RUA1PU1R42FFQDUhQWG+foKAOr6mqPGwgoA6sICw3x9BQB1fc1RY2EFAHVhgWG+vgKAur7mqLGwAoC6sMAwX18BQF1fc9RYWAFAXVhgmK+vAKCurzlqLKwAoC4sMMzXVwBQ19ccNRZWAFAXFhjm6ysAqOtrjhoLKwCoCwsM8/UVANT1NUeNhRUA1IUFhvn6CgDq+pqjxsIKAOrCAsN8fQUAdX3NUWNhBQB1YYFhvr4CgLq+5qixsAKAurDAMF9fAUBdX3PUWFgBQF1YYJivrwCgrq85aiysAKAuLDDM11cAUNfXHDUWVgBQFxYY5usrAKjra44aCysAqAsLDPP1FQDU9TVHjYUVANSFBYb5+goA6vqao8bCCgDqwgLDfH0FAHV9zVFjYQUAdWGBYb6+AoC6vuaosbACgLqwwDBfXwFAXV9z1FhYgf8A/P9u+aPMXrQAAAAASUVORK5CYII="

/***/ }),

/***/ 198:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(206),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(210),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(191)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(211),
  /* scopeId */
  "data-v-b749a7a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(187)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(205),
  /* scopeId */
  "data-v-06c6668a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(189)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(208),
  /* scopeId */
  "data-v-46eed7f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(188)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(207),
  /* scopeId */
  "data-v-31e5e3b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 205:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "wechat-title",
      rawName: "v-wechat-title",
      value: (_vm.$route.meta.title),
      expression: "$route.meta.title"
    }],
    staticClass: "mainContent clear",
    class: {
      'active': _vm.status
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "myNav",
    staticClass: "header"
  }, [_c('div', {
    ref: "myNav",
    staticClass: "header-content clear"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "site-nav fl"
  }, [_c('ul', {
    staticClass: "nav-list fl clear"
  }, [_c('li', {
    ref: "decorate",
    staticClass: "decorate",
    style: ('left:' + _vm.decorateLeft + 'px')
  }), _vm._v(" "), _vm._l((_vm.routeArr), function(item, index) {
    return _c('li', {
      staticClass: "nav-item",
      class: {
        'link': _vm.pathName == item.detailPath
      },
      on: {
        "mouseenter": function($event) {
          return _vm.changeLeft(index)
        },
        "mouseleave": function($event) {
          return _vm.backLeft()
        }
      }
    }, [_c('a', {
      key: item.id,
      staticClass: "route-link",
      class: {
        'activityColor': _vm.formName === item.listPath || _vm.formName === item.detailPath
      },
      attrs: {
        "href": item.url
      }
    }, [_vm._v(_vm._s(item.name))])])
  })], 2), _vm._v(" "), _c('v-login', {
    staticClass: "fl",
    attrs: {
      "loginCssStatus": _vm.loginCssStatus
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo fl"
  }, [_c('a', {
    attrs: {
      "href": "http://breadoffer.com"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(198),
      "alt": ""
    }
  })])])
}]}

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.name != 'Index'),
      expression: "this.$route.name != 'Index'"
    }],
    staticClass: "footer-wrap"
  }, [_c('div', {
    staticClass: "footer-cont clear"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: " fl clear"
  }, [_c('li', {
    staticClass: "fl"
  }, [_c('Tooltip', {
    staticClass: "contact-us",
    attrs: {
      "placement": "top"
    }
  }, [_c('Button', {
    staticClass: "tips",
    on: {
      "mouseenter": function($event) {
        return _vm.enter()
      },
      "mouseleave": function($event) {
        return _vm.leave()
      }
    }
  }, [_vm._v("更多\n\t\t\t        \t"), (_vm.status) ? _c('i', {
    staticClass: "iconfont more-btn"
  }, [_vm._v("")]) : _c('i', {
    staticClass: "iconfont more-btn"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', {
    staticClass: "more-list"
  }, _vm._l((_vm.tipsArr), function(item) {
    return _c('li', [_c('i', {
      staticClass: "iconfont",
      class: {
        'special': item.name == '关于我们'
      },
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.baceUrl + item.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line fl"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "line fl"
  }), _vm._v(" "), _c('li', {
    staticClass: "fl"
  }, [_c('Tooltip', {
    staticClass: "contact-us",
    attrs: {
      "placement": "top"
    }
  }, [_c('Button', {
    staticClass: "tips"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', {
    staticClass: "phone-icon"
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('p', {
    staticClass: "tel"
  }, [_vm._v("15652730502")]), _vm._v(" "), _c('p', {
    staticClass: "work-time"
  }, [_vm._v("工作日：10:00-19:00")]), _vm._v(" "), _c('p', {
    staticClass: "kefu"
  }, [_c('span', [_vm._v("客服电话")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line fl"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "fr weichat"
  }, [_c('Tooltip', {
    staticClass: "contact-us",
    attrs: {
      "placement": "top"
    }
  }, [_c('Button', {
    staticClass: "tips"
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(196),
      "alt": ""
    }
  })])])], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-logo fl"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(197),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "fl"
  }, [_c('a', {
    attrs: {
      "href": "http://breadoffer.com/aboutus/qa.html",
      "target": "_blank"
    }
  }, [_vm._v("常见问题")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "fl weibo"
  }, [_c('a', {
    attrs: {
      "href": "http://www.weibo.com/breadoffer?refer_flag=1005055013_",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])])])
}]}

/***/ }),

/***/ 209:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-header'), _vm._v(" "), _c('v-content'), _vm._v(" "), _c('v-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 210:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 211:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "nav-item nav-item-buttons no-login-toggle",
    class: {
      'right-active': _vm.loginCssStatus
    }
  }, [_c('a', {
    staticClass: "button-default login-btn with-location",
    attrs: {
      "data-base-url": _vm.baceUrl + 'login.html',
      "href": "javascript:void(0);"
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('a', {
    staticClass: "button-light register-btn1 with-location",
    attrs: {
      "data-base-url": _vm.baceUrl + 'register.html',
      "href": "javascript:void(0);"
    }
  }, [_vm._v("注册")])]), _vm._v(" "), _c('div', {
    staticClass: "logined display-none has-login-toggle",
    class: {
      'logined-active': _vm.loginCssStatus
    }
  }, [_c('div', {
    staticClass: "logined-show"
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "iconfont zhankai"
  }, [_vm._v("")]), _vm._v(" "), _c('ul', {
    staticClass: "logined-hide display-none"
  }, [_vm._l((_vm.loginArr), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": _vm.baceUrl + item.url
      }
    }, [_c('span', {
      staticClass: "iconfont",
      class: item.class,
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    }), _c('i', [_vm._v(_vm._s(item.name))])])])
  }), _vm._v(" "), _c('li', {
    staticClass: "li-division"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    staticClass: "user",
    attrs: {
      "src": "/static/img/user.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://breadoffer.com/aboutus/qa.html"
    }
  }, [_c('span', {
    staticClass: "iconfont wenhao"
  }, [_vm._v("")]), _c('i', [_vm._v("帮助中心")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://member.breadoffer.com/logout"
    }
  }, [_c('span', {
    staticClass: "iconfont tuichudenglu"
  }, [_vm._v("")]), _c('i', [_vm._v("注销登录")])])])
}]}

/***/ })

},[186]);


// WEBPACK FOOTER //
// static/js/app.22853fd5ed8685602029.js